import axios from '@bmy/axios';
import config from '@/config/index';
import store from '../store/index'

// Vue.use(axios)

export default {
    /**
     * 通用请求
     * @param {*} option 
     * url 请求地址, data 请求参数, method请求方式默认get
     */
    request1(option) {
        let token = store.getters.userInfo['token']
        let headers = { ...option.headers, token }
        return new Promise((resolve, reject) => {
            axios({
                method: option.method || 'GET',
                url: `${config.baseUrl}${option.url}`,
                data: option.data,
                params: option.params,
                headers: headers
            }).then(function (response) {
                resolve(response)
            }).catch(function (error) {
                console.error(error, `======${option.url}请求出错`)
                reject(error)
            });
        })
    }
}